import TsaRightsInfo from '@/components/copyright/business/copyrightDetail/rightsInfo'
import TsaBasicInfo from '@/components/copyright/business/copyrightDetail/basicInfo'
import TsaProductionTeam from '@/components/copyright/business/copyrightDetail/productionTeam'
import TsaCreateProcess from '@/components/copyright/business/copyrightDetail/createProcess'
import TsaSteps from '@/components/copyright/basics/Steps'
import { draftThirdStepApi, draftFindStageFilesApi, draftApplyApi } from '@/api/copyright/draft'
import { draftConsumeInfoApi } from '@/api/copyright/order'
import { opusUserInfo, updateDramaDraft } from '@/api/copyright/copyright'
import TsaCertificateServiceFeeDialog from '@/components/copyright/business/certificateServiceFeeDialog'
import commonDetail from '@/mixins/detail'
import { mapState, mapActions } from 'vuex'
export default {
    components: {
        TsaSteps,
        TsaRightsInfo,
        TsaBasicInfo,
        TsaCreateProcess,
        TsaCertificateServiceFeeDialog,
        TsaProductionTeam
    },
    data () {
        return {
            id: this.$route.query.id
        }
    },
    computed: {
        ...mapState({
            userInfo: (state) => state.userInfo.me,
            parentIframe: (state) => state.app.parentIframe,
        })
    },
    mixins: [ commonDetail ],
    mounted () {
        this.init();
        // document.body.addEventListener('touchstart', function() {}, true);
        // // 处理滚动（相当于mouseleave）
        // document.querySelector('.scroll').addEventListener('scroll', this.scrollBlur, false);
    },
    beforeUnmount(){
        //document.querySelector('.scroll').removeEventListener('scroll',this.scrollBlur);
    },
    methods: {
        // scrollBlur(){
        //     if (document.activeElement) {
        //         document.activeElement.blur();
        //     }
        // },
        goRecharge(){
            switch (this.parentIframe) {
                case 'ANDROID-RIGHTS':
                    window.testInterface.jumpNativeRecharg(JSON.stringify({copyright:1}));
                    break
                case 'IOS-RIGHTS':
                    window.webkit.messageHandlers.jumpNativeRecharg.postMessage({ copyright:1 });
                    break
                case 'HARMONYOSNEXT-RIGHTS':
                    window.nativeMethod.pushPage('RechargePage', {redirectUrl: 'BannerWebviewPage'});
                    break
                case 'WEIXIN':
                    window.location.href=process.env.VUE_APP_ACCOUNTUI + `/userAccount/buy?sourceType=952310&clientId=952310&partnerType=${this.$getlocalStorage('partnerType')? this.$getlocalStorage('partnerType'):0}`
                    break
                default:
                    this.$router.push({
                        path:'/mine/Account',
                        query:{
                            url:process.env.VUE_APP_ACCOUNTUI+`/userAccount/buy?sourceType=952310&clientId=952310&partnerType=${this.$getlocalStorage('partnerType')?this.$getlocalStorage('partnerType'):0}`
                        }
                    })
            }
        },
        ...mapActions({
            getBalanceInfo: 'balance/getBalanceInfo',
            updateDraftBoxCount: 'app/updateDraftBoxCount',
        }),
        init () {
            draftThirdStepApi(this.id).then(res => {
                if (res.code === 200) {
                    // 如果没有dramaStageDraftList数据，跳转到第二步
                    if (!res.data || !res.data.dramaStageDraftList || res.data.dramaStageDraftList.length === 0) {
                        this.$router.replace({
                            path: '/copyright/copyrightSecond',
                            query: {
                                id: this.id
                            }
                        })
                        return
                    }
                    this.detailHandleData(res.data || {})
                } else {
                    this.$router.replace({
                        path: '/copyright/index',
                        query:{
                            redirect:'false'
                        }
                    })
                }
                
            })
        },
        goback() {
            this.$router.push({
                path: '/copyright/copyrightSecond',
                query: {
                    id: this.id
                }
            })
            UserEventRecord.track(UserEventRecord.trackCommonCopyrightGenerate, {
                '操作类型': '返回修改'
            })
        },
        temporary () {
            UserEventRecord.track(UserEventRecord.trackCommonCopyrightGenerate, {
                '操作类型': '暂存草稿箱'
            })
            this.$TsaConfirmV2.show({
                title: '暂存草稿箱',
                message: '您填写的信息已保存至作品草稿箱，可随时在草稿箱中继续完成认证。',
                type: 'success',
                cancelButtonText: '认证新作品',
                confirmButtonText: '进入草稿箱',
                onCancel: () => {
                    this.$TsaConfirmV2.hide()
                    this.$router.push({
                        path: '/copyright/index',
                        query:{
                            redirect:'false'
                        }
                    })
                },
                onConfirm: () => {
                    this.$TsaConfirmV2.hide()
                    this.$router.push({
                        path: '/copyright/myDraft'
                    })
                },
            })
        },
        loadAll (item) {
            let obj = item.children[item.children.length - 1]
            this.$TsaLoadingV2.show()
            draftFindStageFilesApi({
                lastDramaStageFileId: obj.id,
                stageId: obj.dramaStageId
            }).then(res => {
                this.$TsaLoadingV2.hide()
                let list = res.data || []
                item.children = [ ...item.children, ...list ]
            }).catch(() => {
                this.$TsaLoadingV2.hide()
            })
        },
        confirm(basicInfo) {
            // console.log(basicInfo)
            UserEventRecord.track(UserEventRecord.trackCommonCopyrightGenerate, {
                '操作类型': '确定申请'
            })
            this.$TsaLoadingV2.show()
            draftConsumeInfoApi(this.id).then(({ data } = res) => {
                this.$TsaLoadingV2.hide()
                let { fileTsCount = 0, hasFile = false, minFileTsCount = 0, tsCount = 0 } = data || {}
                if (!hasFile) {
                    this.$TsaToastV2.show({
                        message: '请先上传文件，完成创作过程认证',
                        type: 'error'
                    })
                    return
                }

                this.$refs.TsaCertificateServiceFeeDialog.open({
                    free: fileTsCount >= minFileTsCount ? true : false,
                    name: basicInfo.name,
                    tsCount,
                    minFileTsCount,
                    onConfirm: ($vm) => {
                        this.$TsaLoadingV2.show()
                        draftApplyApi({
                            id:this.id,
                            applyName:this.rightsInfo.applicant
                        }).then(async (res) => {                            
                            this.$TsaLoadingV2.hide()
                            this.$refs.TsaCertificateServiceFeeDialog.hide()
                            this.getBalanceInfo()
                            this.$router.replace({
                                path: '/copyright/copyrightAuthSuccess',
                                query: {
                                    id: res.data.dramaId
                                }
                            })
                            
                        }).catch(async (error) => {
                            console.log(error)
                            this.$TsaLoadingV2.hide()
                            let {code,message}=error.data
                            if (error.status === 400) {
                                if (code === 10001) {
                                    // 可用时间戳余额不足
                                    this.$refs.TsaCertificateServiceFeeDialog.hide()
                                    console.log(this.userInfo)
                                    if (this.userInfo.parentId == '0') {
                                        // 主账号
                                        this.$TsaConfirmV2.show({
                                            title: '提示',
                                            message: '您的余额不足，请充值后再使用',
                                            confirmButtonText: '去充值',
                                            cancelButtonText: '我已充值',
                                            onClose: () => {
                                                this.$TsaConfirmV2.hide()
                                                this.getBalanceInfo()
                                            },
                                            onCancel: () => {
                                                this.$TsaConfirmV2.hide()
                                                this.getBalanceInfo()
                                            },
                                            onConfirm: () => {
                                                UserEventRecord.track(UserEventRecord.trackCommonCopyrightGenerateGuide)
                                                this.goRecharge();
                                            }
                                        })
                                    } else {
                                        // 子账号
                                        this.$TsaConfirmV2.show({
                                            title: '提示',
                                            message: '您的主账号余额不足，请联系主账号充值',
                                            confirmButtonText: '确定',
                                            onConfirm: () => {
                                                this.$TsaConfirmV2.hide()
                                            }
                                        })
                                    }
                                    
                                } else if (code === 10013) {
                                    // 子账号使用次数限额不足
                                    this.$refs.TsaCertificateServiceFeeDialog.hide()
                                    this.$TsaToastV2.show({
                                        message: '您的时间戳已用完，请联系主账号再次分配。',
                                        type: 'error'
                                    })
                                }else if (code === 3010009 || code === 3010010 || code === 3010011) {
                                    // 请先上传文件，完成创作过程认证
                                    this.$TsaToastV2.show({
                                        message: '请先上传文件，完成创作过程认证',
                                        type: 'error'
                                    })
                                }else if(code === 9523103){//未实名或者实名信息变更
                                    // 获取最新实名信息并更新申请人
                                    this.$refs.TsaCertificateServiceFeeDialog.hide()
                                    try {
                                        let {data} = await opusUserInfo()
                                        let applyName
                                        const isSubAccount = this.userInfo.userType == 'AUTHORIZATION_ACCOUNT'
                                        if (isSubAccount) {
                                            if (data.identificationStatus !== 2) {
                                                applyName = data.applyName || ''
                                            } else if (data.showNameType === 0) {
                                                applyName = this.userInfo.masterAccount || ''
                                            } else if (data.showNameType === 1) {
                                                applyName = (this.userInfo.masterAccount || '') + '-' + (this.userInfo.ownerName || '')
                                            } else {
                                                applyName = this.userInfo.ownerName || ''
                                            }
                                        } else {
                                            // 主账号用户未实名的
                                            if (data.identificationStatus == 2) {
                                                applyName = this.userInfo.loginName || ''
                                            } else {
                                                applyName = data.applyName || ''
                                            }
                                        }
                                        if (applyName && this.rightsInfo) {
                                            this.rightsInfo.applicant = applyName
                                        }
                                        // 保存当前数据到草稿
                                        const formData = {
                                            ...this.rightsInfo,
                                            ...this.basicInfo,
                                            ...this.productionTeam,
                                            id: Number(this.id),
                                            saveDraft: true
                                        }
                                        await updateDramaDraft(formData)
                                    } catch (e) {
                                        console.error('更新草稿失败', e)
                                    }
                                    this.$TsaAlertV2.show({
                                        title: '提示',
                                        message: '申请人关联实名状态/信息已变更，请确认最新信息后再次申请认证',
                                        type: 'warn',
                                        confirmButtonText: '去确认',
                                        onConfirm: () => {
                                            this.$TsaAlertV2.hide()
                                        },
                                        onClose: () => {
                                            this.$TsaAlertV2.hide()
                                        },
                                    })
                                    return 
                                } else {
                                    this.$TsaToastV2.show({
                                        message: error.data && error.data.message ? error.data.message : '申请失败',
                                        type: 'error'
                                    })
                                }
                            }
                           
                        })
                    }
                })
            }).catch((error) => {
                this.$TsaLoadingV2.hide()
            })
            
        },
        actions ({ type }) {
            let textTrace = ''
            switch (type) {
                case 'gotoDetail':
                    textTrace = '查看证据详情'
                    break

            }
            UserEventRecord.track(UserEventRecord.trackCommonCopyrightGenerate, {
                '操作类型': textTrace
            })
        }
    }
}